import Flex from 'src/components/Layout/Flex/Flex'
import styled, { css } from 'styled-components'
import { MainWrapper } from 'src/components/Atoms/InputFiles/InputFiles.styles'

export const InputFilesPerTypeFilesWrapper = styled(Flex)<{ isDocumentation?: boolean; }>`
    ${props => {
    const cursorDocStyle = props.isDocumentation ? 'pointer' : 'not-allowed'
    return props.isDocumentation && css`
        cursor: ${cursorDocStyle};

        ${MainWrapper} {
          pointer-events: ${props.isDocumentation ? 'auto' : 'none' };

          label, p {
            cursor: ${cursorDocStyle};
          }
        }

        svg {
          cursor: ${cursorDocStyle};
        }

        path {
          cursor: ${cursorDocStyle};
        }
    `}}
`
